import axios from 'axios';
import { NotificationType } from './notification.types';

export function openNotificationsList(lastNotifShown: number): Promise<{}> {
  return axios.post('/opened_notif_list', { lastNotifShown });
}

export function getNotifications(
  size: number = 10,
  from: number = 0,
): Promise<{
  data: {
    notifList: Array<NotificationType>;
    isNew: boolean;
  };
}> {
  return axios.get('/get_notifs', {
    params: {
      size,
      from,
    },
  });
}

export function setNotificationAsRead(id: number): Promise<{}> {
  return axios.post('/opened_notif', { id });
}
